






import XTextarea from 'vux/src/components/x-textarea/index.vue'

export default {
name: "EditTextModal",
components: {
XTextarea,
},
props: {
textareaValue:String
},
data() {
return {
textareaValueData:this.textareaValue,
textareaValueLength: this.textareaValue.length,
};
},
mounted() {},
beforeDestroy() {},
methods: {
onCloseIcon() {
this.$emit("onCloseEditModal");
},

inputClick() {
console.log("input focus");
this.$refs.messageInput.focus();
},
onSave()
{
if(this.textareaValueLength >= 10)
{
this.$emit("onSaveEditTextModal",this.textareaValueData)
}
else
{
this.$vux.toast.show({
type: "text",
text: '请按要求设置打招呼内容,最少设置10个字符',
});
}
}
},
watch: {
textareaValueData(value) {
this.textareaValueLength = value.length;
console.log("%c⧭", "color: #73998c", value);
},
},
};



// WEBPACK FOOTER //
// ./src/myComponents/EditTextModal/EditTextModal.vue